import { limitNumberOfCharacters } from '@shared/utils/strings';

const SINGLE_TAG_MAX_LENGTH = 13;
const MULTIPLE_TAGS_MAX_LENGTH = 6;

export const getTagLabel = (tags) => {
    const firstItem = tags[0].label;

    if (tags.length === 1) {
        return limitNumberOfCharacters(firstItem, SINGLE_TAG_MAX_LENGTH);
    }

    const others = tags.length - 1;
    return `${limitNumberOfCharacters(firstItem, MULTIPLE_TAGS_MAX_LENGTH)}${others > 0 ? ` and +${others}` : ''}`;
};
